import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 產品主類目 - 新增 Request Schema
 */
export const createProductMainRequestSchema = z.object({
  /** 主類目代碼 */
  pmCode: z.string(),
  /** 主類目名稱(英) */
  nameEn: z.string(),
  /** 主類目名稱(中) */
  nameZh: z.string(),
  /** 可視角色 - 新增/編輯時需將陣列轉成 string */
  role: z.string(),
  /** 中文版文案 */
  copyWritingZh: z.string().nullable().optional(),
  /** 英文版文案 */
  copyWritingEn: z.string().nullable().optional(),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')]).optional(),
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 產品Logo圖檔 */
  productLogo: z.string().nullable(),
  /** 產品版本 - 新增/編輯時需將陣列轉成 string */
  version: z.string(),
  /** 產品簡述（中） */
  descriptionZh: z.string(),
  /** 產品簡述（英） */
  descriptionEn: z.string()
})

/**
 * 產品主類目 - 新增 Request
 */
export interface CreateProductMainRequest
  extends z.infer<typeof createProductMainRequestSchema> {}
